module.exports = __webpack_public_path__ + "img/kumars.4a3c353e.jpg";